import { Flow, Text } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'

export function DesativarAgendaOnlineConfirmBody() {
  const { HORARIO_FINAL_AGENDAMENTO_ENABLED } = useFlags()

  return (
    <Flow direction='vertical'>
      <Text>
        Para habilitar este serviço novamente, será necessário acessar o Portal do Gestor para gerar uma nova
        contra-chave.
      </Text>
      {HORARIO_FINAL_AGENDAMENTO_ENABLED && (
        <Text>
          Ao desabilitar, <strong>não será possível habilitar a agenda online novamente</strong> enquanto o horário
          final estiver ativado para os profissionais.
        </Text>
      )}
    </Flow>
  )
}
